import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("es_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const PUBLIC_PATHS = ["/auth/login", "/auth/signup", "/auth/forgot-password", "/auth/reset-password", "/auth/verify-email", "/auth/resend-verification"];

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    const isPublic = PUBLIC_PATHS.some((p) => url.includes(p));
    if (err?.response?.status === 401 && !isPublic && localStorage.getItem("es_token")) {
      localStorage.removeItem("es_token");
      localStorage.removeItem("es_user");
      window.location.replace("/login?expired=1");
    }
    return Promise.reject(err);
  }
);

export const passwordScore = (pw = "") => {
  let score = 0;
  if (pw.length >= 8) score += 1;
  if (pw.length >= 12) score += 1;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score += 1;
  if (/[0-9]/.test(pw) && /[^A-Za-z0-9]/.test(pw)) score += 1;
  else if (/[0-9]|[^A-Za-z0-9]/.test(pw)) score += 0.5;
  const capped = Math.min(4, Math.round(score));
  const reason = !pw
    ? ""
    : pw.length < 8
    ? "At least 8 characters"
    : !/[A-Za-z]/.test(pw)
    ? "Add a letter"
    : !/[0-9]|[^A-Za-z0-9]/.test(pw)
    ? "Add a number or symbol"
    : capped < 3
    ? "Longer, or mix in capitals and symbols"
    : "";
  return { score: capped, valid: pw.length >= 8 && /[A-Za-z]/.test(pw) && /[0-9]|[^A-Za-z0-9]/.test(pw), reason };
};

export const errMsg = (e) =>
  e?.response?.data?.detail || e?.message || "Something went wrong";
